import { styled } from "styled-components";

export const CellSelectWrap = styled.span`
  width: calc(100% - 30px);
  cursor: text !important;

  > .ant-select-disabled {
    > .ant-select-selector {
      border: 1px solid transparent !important;
      background: transparent !important;
      color: rgba(0, 0, 0, 0.88) !important;
      cursor: text !important;

      > .ant-select-selection-placeholder {
        display: none;
      }
    }

    > .ant-select-arrow {
      display: none;
    }
  }

  & .ant-select .ant-select-selection-item > .ant-typography {
    display: block;
  }
`;